export default "__VITE_ASSET__Cckvv1mP__"